<div *ngIf="!loginDisplay">
    <p>Please Sign-in to see your profile information.</p>
</div>

<div *ngIf="loginDisplay">
    <p>Login Successful</p>
    <p>Request your profile information by clicking profile above</p>
</div>